// extracted by mini-css-extract-plugin
module.exports = {"btns":"newParticipant_btns__CB3zg","selectors":"newParticipant_selectors__41fYN","textarea":"newParticipant_textarea__16cR6"};